/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useEffect, useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {  GROUP_NAME, GROUP_NAME_ERROR, GROUP_NAME_INVALID, LABEL_BTN_CANCEL } from 'src/constants/constant';
import { InputAdornment, TextField } from '@mui/material';
import { getAllGroupById, updateGroup } from 'src/services/groupService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { Cancel01Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useSelector } from 'react-redux';
import type { RootState, EditGroupFormInputs, appConfigs } from '../types/types';
import { checkEventPermission } from 'src/common/utility/utility';

// import MainLayout from '../Layouts/Mainlayout';

interface PropsType {
    id?: number;
}

interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

interface ApiResponse {
    status: number;
    data: {
        data: EditGroupFormInputs[];
    };
}

interface EditApiResponse {
    status: number;
    data: {
        result: number;
        messages: string;
    };
    
}

const EditGroupForm = ({ id, closeModal, refreshPage }: PropsType): JSX.Element => {

    const [groupData, setGroupData] = useState<EditGroupFormInputs | undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const [isEditing, setIsEditing] = useState(false);
 const storedAppConfig = localStorage.getItem("appConfigs");
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  const parsedAppConfig = storedAppConfig
        ? (JSON.parse(storedAppConfig) as appConfigs[])
        : [];
 const CooldownMaxPeriod = parsedAppConfig.find(
        (item) => item.configName === "CooldownMaxPeriod")?.configValue;

const validationSchema = Yup.object().shape({
    groupName: Yup.string().required(GROUP_NAME_ERROR).matches(/^[A-Za-z0-9][A-Za-z0-9 ]*$/, GROUP_NAME_INVALID),
    cooldownPeriod: Yup.number()
        .nullable() // Allows null values
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .transform((value, originalValue) => (originalValue === "" ? null : value)) // Converts empty string to null
        .typeError("Value must be a number")
        .min(1, "Value must be a positive integer")
        .test(
            'max-cooldown',
            `Value cannot be greater than ${CooldownMaxPeriod ?? 'maximum'} days`,
            function(value) {
                if (value == null) return true; // Skip validation if value is null
                if (CooldownMaxPeriod == null) return true; // Skip validation if max period is not set
                return value <= Number(CooldownMaxPeriod);
            }
        ),
});

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue
    } = useForm<EditGroupFormInputs>({
        resolver: yupResolver(validationSchema)
    });

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const fetchgroupData = async () => {
            try {
                const groupid = id;
                if (groupid == null) return;
                setIsLoading(true)
                const res: ApiResponse = await getAllGroupById(groupid);
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                if (res.status === 200 && res.data.data.length > 0) {
                    const group = res.data.data[0];;
                    setGroupData(group);
                    
                    // Set form values
                    setValue("groupName", group.groupName);
                    setValue("cooldownPeriod", group.cooldownPeriod);
                    setValue("clientId", group.clientId);
                }
            } catch (error) {
                console.error("Error fetching group data:", error);
                NotificationManager.error("Error loading group data");
            } finally {
                setIsLoading(false)
            }
        };

        void fetchgroupData();
    }, [id, setValue]);

    const onSubmit = async (data: EditGroupFormInputs): Promise<void> => {

        data.id = id;
        data.modifiedBy =  user?.id ?? 0;
        data.clientId = user?.clientId ?? 0;
        setIsLoading(true)
        await updateGroup(data)
            .then(
                (res: EditApiResponse) => {
                    if (res.status === 200 ) {
                        if(res.data.result === 1) {
                            NotificationManager.success("Group updated successfully")
                            refreshPage()
                        } else if (res.data.messages === 'Campaign group was not added.') {
                            NotificationManager.error('Campaign group already exists');
                        } 
                        else if (res.data.messages === 'Invalid campaign group!') {
                            NotificationManager.error('Campaign group already exists');
                        } 
                        else {
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            NotificationManager.error("Unknown error has occurred");
                        }  
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleEditGroup = ():void => {
        setIsEditing(true);
    }
 const handleCancelEdit = (): void => {
    setValue('groupName', groupData?.groupName ?? '');
    setIsEditing(false);
  };
    return (
        <React.Fragment>
            {
                isLoading ?
                    <div className='flex justify-center items-center relative '><span className="loading loading-spinner text-primary"></span></div> :
                    <form onSubmit={(e) => {e.preventDefault(); void handleSubmit(onSubmit)(e);}}>
                        <div className="px-[16px] pt-[10px]">
                            <div className="grid">
                                <div className={`mb-[5px] w-full relative role-input-container ${!isEditing ? 'disabled' : ''}`} style={{ marginBottom: '30px' }}>
                                    <div >
                                        <Controller
                                            name="groupName"
                                            control={control}
                                            defaultValue={groupData?.groupName}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    fullWidth
                                                    label="Group Name*"
                                                    autoComplete="off"
                                                    placeholder={GROUP_NAME}
                                                    InputProps={{
                                                        style: {
                                                            textAlign: "center",
                                                            color: '#343434',
                                                            fontSize: '18px',
                                                            fontWeight: '700',
                                                            WebkitTextFillColor: '#343434',
                                                            padding: '9px 14px 9px 25px',
                                                        },
                                                        placeholder: `${GROUP_NAME}`,
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                                {!isEditing ? (
                                                                                <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleEditGroup}>
                                                                                    <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" />
                                                                                </div>
                                                                                ) : (
                                                                                <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleCancelEdit}>
                                                                                    <HugeiconsIcon
                                                                                    icon={Cancel01Icon}
                                                                                    size={20}
                                                                                    color="#3a3a3a"
                                                                                    strokeWidth={0.2}
                                                                                    />
                                                                                </div>
                                                                                )}
                                                                            </InputAdornment>                                                           
                                                        ),
                                                    }}
                                                    sx={{
                                                        '& input': {
                                                            textAlign: 'center',
                                                        },
                                                        '& label': {
                                                            textAlign: 'center',
                                                        },
                                                    }}
                                                    disabled={!isEditing}
                                                />
                                            )}
                                        />
                                        {errors.groupName && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="Attention" width={12} height={12} className="mr-1"/>
                                                {errors.groupName.message}
                                            </div>
                                        )}
                                    </div> 
                                </div>
                                <div className="mb-[30px]">
                                    <Controller
                                        name="cooldownPeriod"
                                        control={control}
                                        defaultValue={groupData?.cooldownPeriod}
                                        render={({ field }) => (
                                        <>
                                            <TextField
                                                label="Cooldown Period (days)"
                                                {...field}
                                                fullWidth
                                                autoComplete="off"
                                                InputProps={{
                                                    inputProps: {
                                                    style: {
                                                        textAlign: "left",
                                                        color: '#343434',
                                                        fontSize: '18px',
                                                        fontWeight: '700',
                                                        WebkitTextFillColor: '#343434',
                                                        padding: '9px 14px',
                                                    },
                                                    placeholder: `Cooldown period (days)`,
                                                    },
                                                }}
                                                sx={{
                                                    "& label": {
                                                    textAlign: "center",
                                                    },
                                                    backgroundColor: "#F5F5F5",
                                                }}
                                                 error={!!errors.cooldownPeriod}
                                            />
                                            {errors.cooldownPeriod !== undefined && (
                                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                                    {errors.cooldownPeriod?.message}
                                                </div>
                                            )}

                                        </>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                            <div className="w-full relative col-span-3">
                                <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                            </div>
                            <div className="w-full relative col-span-3">
                                <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]" disabled={isLoading || !checkEventPermission('GROUPS_UPDATE')}>{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                            </div>
                        </div>
                    </form>
            }
        </React.Fragment>

    )
}

export default EditGroupForm